import { NgIf } from '@angular/common';
import { Component, forwardRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ILatLon } from '@curbnturf/entities';
import { IonicModule, ModalController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { CoordinatesMapComponent } from '../coordinates-map/coordinates-map.component';

@Component({
  standalone: true,
  selector: 'curbnturf-map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
  imports: [forwardRef(() => CoordinatesMapComponent), IonicModule, NgIf],
})
export class MapModalComponent implements OnInit, OnChanges, OnDestroy {
  @Input() pins$: Observable<ILatLon[]>;
  @Input() center?: ILatLon;
  @Input() text: string = 'Verify the location for the guest';
  @Input() draggable: boolean = true;
  @Input() locationClicked: (coordinates: ILatLon) => void;

  pinList: ILatLon[];

  get isNative() {
    return Capacitor.isNativePlatform();
  }

  private subscriptions: Subscription[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.subscriptions.push(this.pins$?.subscribe((pins) => (this.pinList = pins)));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.pins$ && changes?.pins$?.currentValue !== changes?.pins$?.previousValue) {
      this.removeSubscriptions();
      this.subscriptions.push(this.pins$?.subscribe((pins) => (this.pinList = pins)));
    }
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }

  removeSubscriptions() {
    this.subscriptions.forEach((sub) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  async onCloseModal() {
    await this.modalController.dismiss();
  }
}
